export const signInUserConfig = {
  signInEP: '/user/sign-in',
  signInTypeEP: '/user/sign-in-type/get',
  sendOTPEP: '/otp/send',
  accessTokenEP: '/user/access-token/get',
};
